import { render, staticRenderFns } from "./VueShareButtons.vue?vue&type=template&id=13c4c3d0&"
import script from "./VueShareButtons.vue?vue&type=script&lang=js&"
export * from "./VueShareButtons.vue?vue&type=script&lang=js&"
import style0 from "./VueShareButtons.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports